import { SITE, PHOTOS } from "../data/content";
import PageHero from "../components/PageHero";
import LegalSections from "../components/LegalSections";

const SECTIONS = [
  {
    h: "Information we collect",
    p: [
      "When you use our contact form we collect your name, email address, optional phone number, the topic you pick, and your message. We also record the date and time you sent it.",
      "We do not collect payment card details on this website. Cabin bookings and payments are handled directly with us by phone or through a separate booking provider.",
      "This website does not use analytics, advertising trackers or its own cookies for visitors. Staff who sign in to read messages receive a secure sign-in cookie.",
    ],
  },
  {
    h: "How we use it",
    p: ["We use what you send only to answer your question, help plan your stay or slip rental, and keep a record of our conversation with you. We do not sell, rent or share your information for marketing."],
  },
  {
    h: "Who can see it",
    p: ["Messages are stored in a private, password-protected system that only Elk Creek Marina staff and our website hosting provider can access. We may disclose information if required by law or to protect our guests and property."],
  },
  {
    h: "Third-party services",
    p: [
      "Fonts and photos are served from our own website. The map on our Contact page is provided by Google and only loads if you choose to show it; when it loads, Google may receive your IP address and set cookies under the Google Privacy Policy.",
      "Links to Facebook, Instagram, Google Maps and any booking provider take you to websites that have their own privacy policies.",
    ],
  },
  {
    h: "How long we keep it",
    p: ["We keep contact messages only as long as we need them to respond to you and for our normal business records, and we delete them sooner if you ask."],
  },
  {
    h: "Security",
    p: ["We use encrypted connections (HTTPS), restricted staff access and spam protection. No system is perfectly secure, but we take reasonable steps to protect what you share with us."],
  },
  {
    h: "Your choices",
    p: [`To see, correct or delete the information you sent us, email ${SITE.email} or call ${SITE.phoneDisplay}. We'll respond as soon as we reasonably can.`],
  },
  {
    h: "Children",
    p: ["This website is not directed to children under 13, and we do not knowingly collect their information."],
  },
  {
    h: "Changes",
    p: ["If we update this policy we will post the new version on this page with a new effective date."],
  },
];

export default function Privacy() {
  return (
    <main data-testid="privacy-page">
      <PageHero image={PHOTOS.lakeHills} eyebrow="Privacy" title="Privacy Policy" subtitle="How we handle the information you share with us through this website." />
      <LegalSections sections={SECTIONS} effective="Effective June 2026" />
    </main>
  );
}
